import { Maybe, None } from "../../lib/misc/option";
import { BaseActionWithNav } from "./BaseActionWithNav";
export class FocusAction extends BaseActionWithNav {
    constructor(layer) {
        super('FOCUS');
        this.layer = layer;
        this.focused = None.instance();
        this.message = {};
        this.exit_ctx = '';
    }
    validate(message) {
        return super.validate(message) && !!message.focused && message.focused.length > 0;
    }
    on_valid_message() {
        this.focused = Maybe(this.layer.clicked);
    }
    async singleton_ctx_handler(message) {
        if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
            return;
        if (message.focused || message.force)
            this.layer.clear();
        await this.layer.select_feature(message.focused);
        this.exit_ctx = 'singleton';
    }
    async set_ctx_handler(message) {
        if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
            return;
        if (message.focused && (!this.layer.ids.includes(message.focused) || message.force))
            this.layer.clear();
        await this.layer.select_feature(message.focused);
        this.exit_ctx = this.layer.ids.length === 1 ? 'singleton' : '';
    }
    async selection_ctx_handler(message) {
        this.layer.clear();
        await this.layer.select_feature(message.focused);
        this.exit_ctx = 'singleton';
    }
    async interpret(message) {
        this.message = message;
        const entry_ctx = this.ctx();
        if (entry_ctx.isNone()) {
            await this.layer.select_feature(message.focused);
            this.exit_ctx = 'singleton';
            return;
        }
        switch (entry_ctx.unwrap().name) {
            case 'singleton':
                await this.singleton_ctx_handler(message);
                break;
            case 'set':
                await this.set_ctx_handler(message);
                break;
            case 'selection':
                await this.selection_ctx_handler(message);
                break;
            default: {
                if (this.focused.isSomeAnd(f => f === message.focused && !message.force))
                    return;
                if (message.focused && (!this.layer.ids.includes(message.focused) || message.force)) {
                    this.layer.clear();
                }
                await this.layer.select_feature(message.focused);
            }
        }
    }
    reset() {
        this.focused = None.instance();
        this.exit_ctx = '';
        this.message = {};
    }
    after_valid_message() {
        let ret_val = {
            zoom: true,
            center: this.message.force || false,
            context: this.exit_ctx,
            fail: false,
            navigate: None.instance()
        };
        this.reset();
        return ret_val;
    }
}
